import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import styles from './AvailabilityConfirm.module.css';
import iconBack from '../../../../images/icon-chevron-left.svg';
import iconCheck from '../../../../images/icon-round-check.svg';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../redux/rootReducer';
import { getConflictedAvailability } from '../../../../redux/availability/actions/availability.action';
import AvailabilityConflict from '../AvailabilityConflict/AvailabilityConflict';
import moment from 'moment';
import { AvailabilityRedirectionContext } from '../../../context/availabilityRedirection';
import { useNavigate } from 'react-router-dom';
export interface addAvailabilityObj {
    locationId: string;
    unitId: string;
    locker: number;
    startDate: string;
    endDate: string;
    openingTime: string;
    closingTime: string;
    locationName: string;
    unitName: string;
}

interface props {
    setShowForm: Dispatch<SetStateAction<boolean>>;
    setShowConfirm: Dispatch<SetStateAction<boolean>>;
    addAvailabilityObj: AnyIfEmpty<object>;
    setShowConflicts: Dispatch<SetStateAction<boolean>>;
    setShowCalendar: Dispatch<SetStateAction<boolean>>;
    setOpen: Dispatch<SetStateAction<boolean>>;
    setShowConflictDelete: Dispatch<SetStateAction<boolean>>;
    setAddAvailabilityObj: Dispatch<SetStateAction<addAvailabilityObj>>;
    showConflicts: boolean;
    showConflictDelete: boolean;
}

const AvailabilityConfirm = ({
    setShowForm,
    setShowConfirm,
    addAvailabilityObj,
    setShowConflicts,
    setShowCalendar,
    setOpen,
    setShowConflictDelete,
    setAddAvailabilityObj,
}: props) => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);
    const lockerType = availabilityRedirectionContext?.locationDetails?.lockerName;
    const [hideBackButton, setHideBackButton] = useState(false);

    useEffect(() => {
        addAvailabilityHandler();
    }, []);

    useEffect(() => {
        if (
            availabilityRedirectionContext?.availabilityData.locationId &&
            availabilityRedirectionContext.availabilityData.locationName &&
            availabilityRedirectionContext.availabilityData.lockerNumber &&
            availabilityRedirectionContext.availabilityData.selectedDate &&
            availabilityRedirectionContext.availabilityData.slotRange &&
            availabilityRedirectionContext.availabilityData.unitId &&
            availabilityRedirectionContext.availabilityData.unitName
        ) {
            setHideBackButton(true);
        }
    }, []);

    const addAvailabilityHandler = async () => {
        const conflictedAvailabilityObj = {
            locationId: addAvailabilityObj.locationId,
            locker: addAvailabilityObj.locker,
            startDate: addAvailabilityObj.startDate,
            openingTime: addAvailabilityObj.openingTime,
            closingTime: addAvailabilityObj.closingTime,
            customAvailability: [
                {
                    day: 'Sunday',
                    openingTime: addAvailabilityObj.openingTime,
                    closingTime: addAvailabilityObj.closingTime,
                    isClosed: false,
                },
                {
                    day: 'Saturday',
                    openingTime: addAvailabilityObj.openingTime,
                    closingTime: addAvailabilityObj.closingTime,
                    isClosed: false,
                },
            ],
        };

        // dispatch(getConflictedAvailability(conflictedAvailabilityObj));
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div
                    onClick={() => {
                        if (!hideBackButton) {
                            setShowConfirm(false);
                            setShowForm(true);
                        } else {
                            availabilityRedirectionContext?.setStep(3);
                            availabilityRedirectionContext?.setAvailabilityData((prevState) => {
                                return {
                                    ...prevState,
                                    slotRange: availabilityRedirectionContext.availabilityData.slotRange,
                                };
                            });
                            availabilityRedirectionContext?.setSelectedSlotsIndex(availabilityRedirectionContext.selectedSlotsIndex);
                            navigate('/create-appointment');
                        }
                    }}
                    className={styles.back}>
                    <img src={iconBack} alt="back" />
                </div>

                <h2 className={styles.title}>Add Availability</h2>
            </div>
            <div className={styles.body}>
                <div className={styles.checkContainer}>
                    <img className={styles.check} src={iconCheck} alt="Check" />
                </div>
                <p className={styles.confirmText}>This availability will be added to the calendar.</p>
                <ul className={styles.formData}>
                    <li>
                        <label>Property</label>
                        <p>{addAvailabilityObj.locationName}</p>
                    </li>
                    <li>
                        <label>Start Date</label>
                        <p>{moment(addAvailabilityObj.startDate).format('MM-DD-YYYY')}</p>
                    </li>
                    <li>
                        <label>Opening Hours</label>
                        <p>{moment(addAvailabilityObj.openingTime, 'hh:mm A').format('hh:mm A')} </p>
                    </li>
                    {lockerType?.toLowerCase() !== 'bms' && (
                        <li>
                            <label>Locker Number</label>
                            <p>{addAvailabilityObj.locker}</p>
                        </li>
                    )}
                    <li>
                        <label>Unit</label>
                        <p>{addAvailabilityObj.unitName}</p>
                    </li>
                    <li>
                        <label>End Date</label>
                        <p>{moment(addAvailabilityObj.endDate).format('MM-DD-YYYY')}</p>
                    </li>
                    <li>
                        <label>Closing Hours</label>
                        <p>{moment(addAvailabilityObj.closingTime, 'hh:mm A').format('hh:mm A')}</p>
                    </li>
                    <li>
                        <label>Buffer Hour</label>
                        <p>1 Hr</p>
                    </li>
                </ul>

                <p className={styles.bufferHourNote}>
                    *Any appointment made will have a one-hour buffer before and after. This allows visitors to pickup their keys up to{' '}
                    <b>15 minutes</b> and return their keys up to <b>45 minutes</b> after their appointment time without conflict.
                </p>

                {
                    <AvailabilityConflict
                        setShowCalendar={setShowCalendar}
                        setShowForm={setShowForm}
                        setShowConfirm={setShowConfirm}
                        setShowConflicts={setShowConflicts}
                        setShowConflictDelete={setShowConflictDelete}
                        addAvailabilityObj={addAvailabilityObj}
                        setOpen={setOpen}
                        location={addAvailabilityObj.locationName}
                        setAddAvailabilityObj={setAddAvailabilityObj}
                    />
                }
            </div>
        </div>
    );
};

export default AvailabilityConfirm;
